import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import img from '../assets/AppDownload.png';
import img2x from '../assets/AppDownload@2x.png';

import classes from './App.scss';

const style = {
  backgroundColor: 'pink',
  width: '100%',
  maxWidth: 360,
  margin: '0 auto',
  height: 48,
};

class App extends React.Component {
  render() {
    return (
      <div className={classes.app}>
        <div className={classes.wrapper}>
          <div className="img">
            <img
              src={img}
              srcSet={`${img2x} 2x`}
              alt="Simpl - jetzt als mobile App!"
            />
          </div>
          <div className="row overview">
            <div className="col-xs-12 text-center">
              <p>
                <b>Willkommen zur Beta der iOS und Android Apps von SiMPL!</b>
              </p>
            </div>
            <div className="col-xs-12 col-sm-6 text-center">
              <h2 className={'text-left'}>Android</h2>

              <a
                href="https://play.google.com/apps/testing/com.haparo.SiMPL"
                className={'button button-primary'}
              >
                Zur Beta Anmeldung
              </a>

              <p>
                Sollten Sie ein Android Gerät, also bspw. Samsung, Sony, Google
                etc verwenden, verwenden Sie bitte diesen Link.
              </p>
            </div>
            <div className="col-xs-12 col-sm-6 text-center">
              <h2 className={'text-left'}>iPhone</h2>

              <a
                href="https://testflight.apple.com/join/e4l68bAL"
                className={'button button-primary'}
              >
                Zur Beta Anmeldung
              </a>

              <p>
                Sollten Sie ein iPhone besitzen, verwenden Sie bitte diesen
                Link.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
App.propTypes = {
  login: PropTypes.object,
  location: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
};
App.contextTypes = {
  store: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  login: state.login,
});
const mapActionCreators = {};
export default connect(mapStateToProps, mapActionCreators)(App);



// WEBPACK FOOTER //
// ./src/routes/App/components/App.js